"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _linkModule = _interopRequireDefault(require("./link.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactRouterDom = require("react-router-dom");
var _excluded = ["to", "className", "children"],
  _excluded2 = ["href", "className", "onClick", "children", "external"];
var ExternalLink = function ExternalLink(_ref) {
  var to = _ref.to,
    className = _ref.className,
    children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("a", Object.assign({
    href: to,
    className: (0, _classnames.default)(_linkModule.default.link, className),
    rel: "noopener noreferrer"
  }, rest), children);
};
var Link = function Link(_ref2) {
  var href = _ref2.href,
    className = _ref2.className,
    onClick = _ref2.onClick,
    children = _ref2.children,
    external = _ref2.external,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  var Element = external ? ExternalLink : _reactRouterDom.Link;
  return /*#__PURE__*/_react.default.createElement(Element, Object.assign({
    to: href,
    onClick: onClick,
    className: (0, _classnames.default)(_linkModule.default.link, className)
  }, rest), children);
};
exports.Link = Link;